import { Button } from "@/components/ui/button";

export default function AdminLogin() {
  const startLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm border border-ink bg-card p-10">
        <div className="flex items-baseline gap-2">
          <span className="text-2xl font-semibold text-foreground">TruVerse</span>
          <span className="text-[10px] font-semibold uppercase tracking-[0.25em] text-accent">Admin</span>
        </div>
        <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
          Sign in with your authorised Google account to manage leads, content and downloads.
        </p>
        <Button onClick={startLogin} data-testid="admin-google-login-btn" className="mt-8 w-full rounded-sm bg-accent py-6 text-sm font-semibold text-accent-foreground hover:bg-accent/85">
          Continue with Google
        </Button>
      </div>
    </div>
  );
}
